import { useCallback, useState } from 'react';

export const useItemsFilters = <T>(items: T[]) => {
  const [visibleItems, setVisibleItems] = useState<T[]>(items);

  const filterItems = useCallback(
    (searchValue: string, filterHandler: (item: T) => boolean) => {
      const search = searchValue.toLowerCase();
      if (!search) {
        setVisibleItems(items);
        return;
      }

      setVisibleItems(items.filter((item) => filterHandler(item)));
    },
    [items]
  );

  return { filterItems, visibleItems };
};
